var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormControlLabel, FormGroup, MenuItem, Select, Typography, } from "@mui/material";
import CustomReadOnly from "../ReadOnlyBox/CustomReadOnly";
const CustomSelect = (props) => {
    const { value, onChange, label, customStyle, textStyle, options, placeholder, boxStyle, optionsStyle, readOnly = false } = props, muiProps = __rest(props, ["value", "onChange", "label", "customStyle", "textStyle", "options", "placeholder", "boxStyle", "optionsStyle", "readOnly"]);
    // Normalize value for placeholder
    const normalizedValue = value !== null && value !== void 0 ? value : "";
    const selectedOption = options.find((option) => option.value === value);
    if (readOnly) {
        return (_jsx(CustomReadOnly, { label: label || "", content: selectedOption ? selectedOption.title : "" }));
    }
    return (_jsxs(FormGroup, { sx: Object.assign({ "& .MuiFormControlLabel-root": {
                marginLeft: 0,
                marginRight: 0,
            } }, customStyle), children: [label && (_jsx(FormControlLabel, { control: _jsx(Typography, { variant: "h6" }), label: _jsx(Typography, { sx: Object.assign({ fontSize: "16px" }, textStyle), children: label }) })), _jsxs(Select, Object.assign({ value: normalizedValue, onChange: (event) => onChange(event.target.value), displayEmpty: true, sx: Object.assign({}, boxStyle) }, muiProps, { children: [_jsx(MenuItem, { value: "", disabled: true, style: optionsStyle, children: placeholder || "انتخاب کنید" }), options.map((option, index) => (_jsx(MenuItem, { value: option.value, style: Object.assign({}, optionsStyle), children: option.title }, `${option.value}${index}`)))] }))] }));
};
export default CustomSelect;
